import React, { useMemo, useState, useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import API from '../../../create/api';
import querystring from 'querystring';
import _ from 'lodash';
import Grid from '@material-ui/core/Grid';
import { useSelector, useStore } from 'react-redux';
import MobileTableRow from './table.mobile-table-row';
import DesktopTable from './RidersBookDesktop';
import axios from 'axios';
import * as helper from '../../../../helper/index';
import { toastr } from 'react-redux-toastr';
import RiderFilters, { ParcelDate } from './RiderFilters';
import moment from 'moment';
import MobilePagination from './mobile.pagination';
import { useLocation } from 'react-router-dom';
import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';

export const useStyles = makeStyles((theme) => ({
  table: {
    minWidth: 700,
  },
  modal: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  paper: {
    backgroundColor: theme.palette.background.paper,
    border: '2px solid #000',
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
  },
  fromControl: {
    width: '100%',
  },
  tdBorder: { border: '1px black solid', fontSize: '20px', padding: '0 5px' },
  onlyPrint: { display: 'none' },
  hidePrint: {},
  printStyle: {},
  numberSize: { fontSize: '30px' },
  '@media print': {
    'table tr': {
      pageBreakBefore: 'always',
    },
    hidePrint: {
      display: 'none',
    },
    onlyPrint: { display: 'block' },
    printStyle: {
      border: '1px black solid',
      fontSize: '20px',
      padding: '0 5px',
    },
    numberSize: { fontSize: '30px' },
  },
}));

export default function RidersBook() {
  const classes = useStyles();
  const store = useStore();
  const location = useLocation();

  const getStatusFromUrl = () => {
    const params = new URLSearchParams(location.search);
    const statusInParam = params.get('status_in');
    if (statusInParam) {
      return statusInParam.split(',');
    }

    return ['ON_DELIVERY', 'DELIVERED_BY_RIDER', 'RETURNED_BY_RIDER', 'PARTIALLY_DELIVERED_BY_RIDER'];
  };

  const [get_rows, setRows]: [any[], any] = useState([]);
  const [sums, setSums]: any = useState({});
  const [get_parcel_date, set_parcel_date] = useState<ParcelDate>({});
  const [loading, set_loading] = useState(false);
  const [get_status, set_status] = React.useState<string[]>(getStatusFromUrl());
  const [statusIDSetAction, setStatusIDSetAction]: [string | null, any] = useState(null);
  const [area, setArea]: any = useState(null);
  const [get_payment_date, set_payment_date] = useState(moment().format('YYYY-MM-DD'));
  const [checkboxes, setCheckboxes]: [Record<string, boolean>, any] = useState({});
  const [showFilters, setShowFilters] = useState(false);
  const [showBulkActions, setShowBulkActions] = useState(false);
  const [get_search, set_search] = useState('');
  const [get_total_parcel_count, set_total_parcel_count] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);

  const limit = useSelector((state: any) => state?.parcel?.parcelTableLimit);
  const sortBy = useSelector((state: any) => state?.parcel?.parcelTableSort);

  React.useEffect(() => {
    set_status(getStatusFromUrl());
  }, [location.search]);

  React.useEffect(() => {
    fetchAPI();
  }, [limit, sortBy, currentPage, get_status]);

  async function fetchAPI() {
    set_loading(true);

    function date_filter() {
      if (get_parcel_date.startDate && !get_parcel_date.endDate) {
        return {
          booking_date_gte: moment(get_parcel_date.startDate).format('YYYY-MM-DD'),
          booking_date_lt: moment(get_parcel_date.startDate).add(1, 'd').format('YYYY-MM-DD'),
          _start: (currentPage - 1) * limit,
          _limit: limit,
        };
      }
      if (get_parcel_date.startDate && get_parcel_date.endDate) {
        return {
          booking_date_gte: moment(get_parcel_date.startDate).format('YYYY-MM-DD'),
          booking_date_lt: moment(get_parcel_date.endDate).add(1, 'd').format('YYYY-MM-DD'),
          _start: (currentPage - 1) * limit,
          _limit: limit,
        };
      }
      return {
        _start: (currentPage - 1) * limit,
        _limit: limit,
      };
    }

    const set_date_filter = date_filter();

    let param: Record<string, any> = {
      _q: get_search,
      status_in: get_status,
      rider: store.getState().auth?.user?.rider?.id,
      area: area?.value,
      _sort: sortBy,
      ...set_date_filter,
    };

    param = _.pickBy(param, _.identity);

    const qs = querystring.encode(param);

    const url = `${process.env.REACT_APP_API_SERVER}/parcels?${qs}`;
    const [parcels, count]: any[] = await Promise.all([
      API.getAll(url),
      API.count(`${process.env.REACT_APP_API_SERVER}/parcels/count?${qs}`),
    ]);

    setTimeout(() => {
      let totalCollected = 0;

      for (let i = 0; i < parcels.length; i++) {
        const parcel = parcels[i];
        if (['DELIVERED_BY_RIDER'].includes(parcel.status)) {
          totalCollected += parcel.merchant_COD;
        }
        if (['RETURNED_BY_RIDER'].includes(parcel.status)) {
          continue;
        }
        if (['PARTIALLY_DELIVERED_BY_RIDER'].includes(parcel.status)) {
          totalCollected += parcel.collected_amount;
        }
      }
      setSums({ totalCollected });
      setRows(parcels);
      set_loading(false);

      set_total_parcel_count(count);
    }, 0);
  }

  const handlePrint = () => {
    store.dispatch({ type: 'CLOSE_SIDEBAR' });
    setTimeout(() => {
      window.print();
    }, 100);
  };

  const handleCheckBox = (event: React.ChangeEvent<HTMLInputElement>, index: number) => {
    setCheckboxes({ ...checkboxes, [event.target.name]: event.target.checked });
  };

  const checkAllParcel = (event: React.ChangeEvent<HTMLInputElement>) => {
    let update = { ...checkboxes };
    for (let i = 0; i < get_rows.length; i++) {
      update = { ...update, [`checkbox-${get_rows[i].id}`]: event.target.checked };
    }
    setCheckboxes(update);
  };

  const allSelectedCheck = useMemo(
    () => Object.values(checkboxes).filter((val) => val).length === get_rows.length,
    [get_rows, checkboxes],
  );

  const selectedParcels = useMemo(
    () =>
      Object.entries(checkboxes)
        .filter(([, val]) => val)
        .map(([key]) => key.split('-')[1])
        .map((id) => get_rows.find((r) => r.id === parseInt(id))),
    [checkboxes, get_rows],
  );

  async function updateCheckboxStatus() {
    for (let i = 0; i < Object.entries(checkboxes).length; i++) {
      const [parcelID, value] = Object.entries(checkboxes)[i];
      try {
        if (value && statusIDSetAction) {
          await axios.put(
            `${process.env.REACT_APP_API_SERVER}/parcels/${parcelID.split('-')[1]}`,
            {
              status: statusIDSetAction,
              ...(statusIDSetAction && ['DELIVERED', 'RETURNED', 'PARTIALLY_DELIVERED'].includes(statusIDSetAction)
                ? { payment_date: get_payment_date }
                : {}),
            },
            {
              headers: {
                Authorization: `Bearer ${store.getState().auth.jwt}`,
              },
            },
          );

          toastr.success(
            'Parcel Updated',
            `Parcel ID:${parcelID?.split('-')?.[1] ?? ''} Status to ${statusIDSetAction} updated`,
          );
          setCheckboxes({});
          setStatusIDSetAction(null);
        }
      } catch (error: any) {
        helper.axiosErrorHandling(error);
      }
    }
    fetchAPI();
  }

  const paginationProps = {
    total: get_total_parcel_count,
    selected: selectedParcels.length,
    loading: loading,
    currentPage: currentPage,
    limit: limit,
    onPageChange: (newPage: number) => setCurrentPage(newPage),
    onLimitChange: (newLimit: number) => {
      store.dispatch({ type: 'UPDATE_PARCEL_TABLE_LIMIT', payload: newLimit });
      setCurrentPage(1);
    },
    onSortChange: (newSort: string) => {
      store.dispatch({ type: 'UPDATE_PARCEL_TABLE_SORT', payload: newSort });
      setCurrentPage(1);
    },
  };

  return (
    <Grid container>
      <Grid item xs={12} md={12} className={classes.hidePrint}>
        <RiderFilters
          loading={loading}
          getStatus={get_status}
          setStatus={set_status}
          getParcelDate={get_parcel_date}
          setParcelDate={set_parcel_date}
          area={area}
          setArea={setArea}
          fetchAPI={fetchAPI}
          handlePrint={handlePrint}
          showFilters={showFilters}
          setShowFilters={setShowFilters}
          showBulkActions={showBulkActions}
          setShowBulkActions={setShowBulkActions}
          statusIDSetAction={statusIDSetAction}
          setStatusIDSetAction={setStatusIDSetAction}
          getPaymentDate={get_payment_date}
          setPaymentDate={set_payment_date}
          updateCheckboxStatus={updateCheckboxStatus}
          get_search={get_search}
          set_search={set_search}
        />

        <div className="flex justify-between items-center mb-5">
          <div className="text-lg font-semibold text-gray-700 bg-gray-100 px-4 py-2 rounded-md shadow-sm">
            Total Amount: {sums.totalCollected}
          </div>
          <div className="flex">
            <input
              className="bg-primary-blue px-4 py-2 rounded-md text-white font-bold hover:cursor-pointer shadow-blue-100 shadow-xl mr-3"
              onClick={fetchAPI}
              type="button"
              value="Refresh"
            />
            <input
              className="bg-primary-blue px-4 py-2 rounded-md text-white font-bold hover:cursor-pointer shadow-blue-100 shadow-xl"
              onClick={handlePrint}
              type="button"
              value="Print"
            />
          </div>
        </div>
      </Grid>
      <DesktopTable
        get_rows={get_rows}
        fetchAPI={fetchAPI}
        checkboxes={checkboxes}
        handleCheckBox={handleCheckBox}
        checkAllParcel={checkAllParcel}
        allSelectedCheck={allSelectedCheck}
        get_total_parcel_count={get_total_parcel_count}
        selectedParcels={selectedParcels}
        page={currentPage}
        limit={limit}
        loading={loading}
        paginationProps={paginationProps}
      />
      <Grid item xs={12} md={12} className="block sm:hidden">
        <MobilePagination {...paginationProps} />
        {loading ? (
          <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '200px' }}>
            <CircularProgress />
          </Box>
        ) : (
          get_rows.map((row: any, i: number) => (
            <MobileTableRow
              row={row}
              index={(currentPage - 1) * limit + i}
              refreshData={fetchAPI}
              key={row.id}
              checkboxes={checkboxes}
              handleCheckBox={handleCheckBox}
            />
          ))
        )}
        <MobilePagination {...paginationProps} />
      </Grid>
    </Grid>
  );
}
